import { render } from "./LockedIcon.vue?vue&type=template&id=ea29edfc&ts=true"
import script from "./LockedIcon.vue?vue&type=script&lang=ts"
export * from "./LockedIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__